import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import '../assets/css/Notification.css';
import { notificationType } from '../types';
import { hideNotification } from '../actions/notifications';

Notification.propTypes = {
    outerClass: PropTypes.string.isRequired,
    buttonClass: PropTypes.string.isRequired,
    notification: notificationType.isRequired,
};

function Notification(props) {
    const {
        outerClass,
        buttonClass,
        notification,
    } = props;
    const dispatch = useDispatch();
    const onClose = () => dispatch(hideNotification(notification.id));
    return (
        <div className={`notification ${outerClass}`}>
            <span>{notification.text}</span>
            <button type="button" className={`close-button button-small ${buttonClass}`} onClick={onClose}>
                <span aria-label="Close" role="img">&#10060;</span>
            </button>
        </div>
    );
}

export default Notification;
